// import React, { useState, useEffect } from 'react';
// import { Col, Form, Modal, Row } from 'react-bootstrap';
// import SbCancelBtn, { SbAddBtn, SBSaveUpdateBtn } from '../Buttons/Buttons';
// import Select from 'react-select';
// import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
// import deleteImg from '../../assets/images/Settings/deleteImage.svg';  // Assuming delete image
// import { useDispatch, useSelector } from 'react-redux';
// import { loadBranchDropdownData, loadSlocDropdownData, postUserManagementSlocDatas } from '../../redux/action';
// import * as HeaderAuthentication from '../HeaderAuthentication';

// const AddSlocModal = (props) => {
//     const dispatch = useDispatch();
//     const { singleUserData, userID, userManagenemtData } = props;
//     const { slocDropdown, branchDropdown } = useSelector((state) => state.data);

//     const [userName, setUserName] = useState("");
//     const [selectedBranch, setSelectedBranch] = useState(null);
//     const [selectedSloc, setSelectedSloc] = useState(null);
//     const [storageLocation, setStorageLocation] = useState([]);
//     const [errorMessage, setErrorMessage] = useState("");
//     const [filteredSlocs, setFilteredSlocs] = useState([]);

//     useEffect(() => {
//         if (singleUserData && singleUserData.length > 0) {
//             const user = singleUserData[0];
//             if (user && user.FirstName) {
//                 setUserName(user.FirstName);
//             }
//             setStorageLocation(user.UserSloc);
//         }
//     }, [singleUserData]);

//     useEffect(() => {
//         dispatch(loadSlocDropdownData());
//         dispatch(loadBranchDropdownData());
//     }, [dispatch]);

//     const handleBranchChange = (branch) => {
//         console.log("Selected Branch:", branch);
//         setSelectedBranch(branch);
//         setErrorMessage(""); // Clear error message when branch is changed

//         if (branch && branch.BranchCode) {
//             // Filter Slocs based on ReportingToCode
//             const filteredSlocs = slocDropdown.filter(sloc => sloc.ReportingToCode === branch.BranchCode);
//             setFilteredSlocs(filteredSlocs); // Store filtered slocs in state
//         }
//     };

//     const handleSlocChange = (sloc) => {
//         setSelectedSloc(sloc);
//         setErrorMessage(""); // Clear error message when sloc is changed
//     };

//     const handleAddStorage = () => {
//         if (selectedBranch && selectedSloc) {
//             if (selectedBranch.value === selectedSloc.value) {
//                 setErrorMessage("Branch and Sloc cannot be the same.");
//                 return;
//             }

//             const isDuplicate = storageLocation.some(
//                 (location) =>
//                     location.BranchID === selectedBranch.value &&
//                     location.CustSlocID === selectedSloc.value
//             );

//             if (isDuplicate) {
//                 setErrorMessage("This Branch-Sloc combination already exists.");
//                 return;
//             }

//             setErrorMessage(""); // Clear error if no issues

//             const newStorageLocation = {
//                 BranchID: selectedBranch.value,
//                 BranchName: selectedBranch.label,
//                 CustSlocID: selectedSloc.value,
//                 StorageLocationName: selectedSloc.label,
//             };

//             setStorageLocation([...storageLocation, newStorageLocation]);
//             setSelectedBranch(null);
//             setSelectedSloc(null);
//         } else {
//             alert("Please select both Branch and Sloc");
//         }
//     };

//     const handleRemoveStorage = (index) => {
//         const updatedStorageLocation = [...storageLocation];
//         updatedStorageLocation.splice(index, 1);
//         setStorageLocation(updatedStorageLocation);
//     };

//     const AddUserManagementSlocData = (e) => {
//         e.preventDefault();

//         if (storageLocation.length === 0) {
//             setErrorMessage("No storage locations added. Please add a storage location before saving.");
//             return;
//         } else {
//             setErrorMessage("");
//         }

//         const slocData = {
//             UserID: userID,
//             UserSloc: storageLocation.map(location => ({
//                 BranchID: location.BranchID,
//                 CustSlocID: location.CustSlocID,
//             })),
//         };

//         const requestOption = {
//             method: "POST",
//             mode: "cors",
//             headers: HeaderAuthentication.postExcomatixAuth,
//             body: JSON.stringify(slocData),
//         };

//         dispatch(postUserManagementSlocDatas(requestOption, props.handleCloseSlocModal, userManagenemtData));
//     };

//     return (
//         <Modal show={props.openSlocModal} onHide={props.handleCloseSlocModal} className="add-customer-modal">
//             <Modal.Header closeButton>
//                 <Modal.Title>Add Storage Locations</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Row className="customer-form-fields customer-branch-plant-form-fields">
//                     <Col>
//                         <Row>
//                             <Col md={12}>
//                                 <div>
//                                     <label>Username</label>
//                                     <Form.Control
//                                         type="text"
//                                         value={userName}
//                                         onChange={(e) => setUserName(e.target.value)}
//                                         placeholder="Enter Username"
//                                     />
//                                 </div>
//                             </Col>
//                         </Row>
//                         <div className="wq-modal-table-container">
//                             <Row>
//                                 <Col md={6}>
//                                     <div>
//                                         <label>Plant</label>
//                                         <Select
//                                             className="react-select-container"
//                                             classNamePrefix="react-select"
//                                             value={selectedBranch ? { value: selectedBranch.value, label: selectedBranch.label } : null}
//                                             onChange={handleBranchChange}
//                                             options={branchDropdown}
//                                             placeholder="Select Plant"
//                                         />
//                                     </div>
//                                 </Col>
//                                 <Col md={6}>
//                                     <div>
//                                         <label>Sloc</label>
//                                         <Select
//                                             className="react-select-container"
//                                             classNamePrefix="react-select"
//                                             value={selectedSloc ? { value: selectedSloc.value, label: selectedSloc.label } : null}
//                                             onChange={handleSlocChange}
//                                             // options={slocDropdown}
//                                             options={filteredSlocs}
//                                             placeholder="Select Sloc"
//                                         />
//                                     </div>
//                                 </Col>
//                             </Row>

//                             {/* Display Error Message */}
//                             {errorMessage && (
//                                 <Row>
//                                     <Col md={12} className="text-danger text-center">
//                                         {errorMessage}
//                                     </Col>
//                                 </Row>
//                             )}

//                             <Row>
//                                 <Col className="d-flex justify-content-center pt-4">
//                                     <SbAddBtn btnName="Add Storage Location" onClickEffect={handleAddStorage} />
//                                 </Col>
//                             </Row>

//                             <Row className="add-sloc-table-div">
//                                 <TableContainer
//                                     component={Paper}
//                                     sx={{ maxHeight: 440 }}
//                                     className="table-container add-sloc-table-container"
//                                     style={{ boxShadow: "none" }}
//                                 >
//                                     <Table stickyHeader>
//                                         <TableHead>
//                                             <TableRow>
//                                                 <TableCell className="table-header-div">Plant</TableCell>
//                                                 <TableCell className="table-header-div">Sloc</TableCell>
//                                                 <TableCell className="table-header-div">Action</TableCell>
//                                             </TableRow>
//                                         </TableHead>
//                                         <TableBody>
//                                             {storageLocation.map((location, index) => (
//                                                 <TableRow key={index}>
//                                                     <TableCell>{location.BranchName}</TableCell>
//                                                     <TableCell>
//                                                         {location.StorageLocationName}
//                                                         {location.Status === "Inactive" && (
//                                                             <span style={{ color: "red", fontStyle: "italic" }}> (Inactive)</span>
//                                                         )}
//                                                     </TableCell>
//                                                     <TableCell>
//                                                         <img
//                                                             src={deleteImg}
//                                                             alt="Delete"
//                                                             onClick={() => handleRemoveStorage(index)}
//                                                             style={{ cursor: "pointer" }}
//                                                         />
//                                                     </TableCell>
//                                                 </TableRow>
//                                             ))}
//                                         </TableBody>
//                                     </Table>
//                                 </TableContainer>
//                             </Row>
//                         </div>
//                     </Col>
//                 </Row>
//             </Modal.Body>
//             <Modal.Footer>
//                 <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseSlocModal} />
//                 <SBSaveUpdateBtn btnName="Save" onClickEffect={AddUserManagementSlocData} />
//             </Modal.Footer>
//         </Modal>
//     );
// };

// export default AddSlocModal;







import React, { useState, useEffect } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import SbCancelBtn, { SbAddBtn, SBSaveUpdateBtn } from '../Buttons/Buttons';
import { MultiSelect } from "react-multi-select-component";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import deleteImg from '../../assets/images/Settings/deleteImage.svg';
import { useDispatch, useSelector } from 'react-redux';
import { loadBranchDropdownData, loadSlocDropdownData, postUserManagementSlocDatas } from '../../redux/action';
import * as HeaderAuthentication from '../HeaderAuthentication';
import noDataFound from '../../assets/images/no-data-found.svg'

const AddSlocModal = (props) => {
    const dispatch = useDispatch();
    const { singleUserData, userID, userManagenemtData } = props;
    const { slocDropdown, branchDropdown } = useSelector((state) => state.data);

    const [userName, setUserName] = useState("");
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [selectedSlocs, setSelectedSlocs] = useState([]);
    const [storageLocation, setStorageLocation] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [filteredSlocs, setFilteredSlocs] = useState([]);

    // useEffect(() => {
    //     if (singleUserData && singleUserData.length > 0) {
    //         const user = singleUserData[0];
    //         if (user && user.FirstName) {
    //             setUserName(user.FirstName);
    //         }
    //         setStorageLocation(user.UserSloc || []);
    //     }
    // }, [singleUserData]);

    useEffect(() => {
        if (props.openSlocModal) {
            if (singleUserData && singleUserData.length > 0) {
                const user = singleUserData[0];
                setUserName(user?.FirstName || "");
                setStorageLocation(user?.UserSloc || []);
            } else {
                setUserName("");
                setStorageLocation([]);
            }
            setSelectedBranches([]);
            setSelectedSlocs([]);
            setFilteredSlocs([]);
            setErrorMessage("");
        }
    }, [props.openSlocModal, singleUserData]);

    useEffect(() => {
        dispatch(loadSlocDropdownData());
        dispatch(loadBranchDropdownData());
    }, [dispatch]);

    // useEffect(() => {
    //     if (storageLocation.length > 0) {
    //         const preSelectedBranches = [];
    //         const preSelectedSlocs = [];

    //         storageLocation.forEach((location) => {
    //             const branch = branchDropdown.find(branch => branch.value === location.BranchID);
    //             const sloc = slocDropdown.find(sloc => sloc.value === location.CustSlocID);

    //             if (branch && !preSelectedBranches.some(b => b.value === branch.value)) {
    //                 preSelectedBranches.push({ label: branch.label, value: branch.value });
    //             }
    //             if (sloc && !preSelectedSlocs.some(s => s.value === sloc.value)) {
    //                 preSelectedSlocs.push({
    //                     label: sloc.label,
    //                     value: sloc.value,
    //                     ReportingToCode: sloc.ReportingToCode
    //                 });
    //             }
    //         });

    //         setSelectedBranches(preSelectedBranches);
    //         setSelectedSlocs(preSelectedSlocs);

    //         const filtered = slocDropdown.filter(sloc =>
    //             preSelectedBranches.some(branch => branch.value === sloc.ReportingToCode)
    //         );
    //         setFilteredSlocs(filtered);
    //     } else {
    //         setSelectedBranches([]);
    //         setSelectedSlocs([]);
    //         setFilteredSlocs([]);
    //     }
    // }, [storageLocation, branchDropdown, slocDropdown]);

    // const handleBranchChange = (selected) => {
    //     setSelectedBranches(selected);
    //     setErrorMessage("");

    //     if (selected.length > 0) {
    //         const branchCodes = selected.map(branch => branch.BranchCode);
    //         const filtered = slocDropdown.filter(sloc => branchCodes.includes(sloc.ReportingToCode));

    //         setFilteredSlocs(filtered);

    //         const autoSelectedSlocs = filtered.map(sloc => ({
    //             label: sloc.label,
    //             value: sloc.value,
    //             ReportingToCode: sloc.ReportingToCode, // Keep branch reference
    //         }));

    //         setSelectedSlocs(autoSelectedSlocs);
    //     } else {
    //         setFilteredSlocs([]);
    //         setSelectedSlocs([]);
    //     }
    // };

    useEffect(() => {
        if (storageLocation.length > 0 && branchDropdown.length > 0 && slocDropdown.length > 0) {
            const preSelectedBranches = [];
            const preSelectedSlocs = [];

            storageLocation.forEach((location) => {
                const branch = branchDropdown.find(branch => branch.value === location.BranchID);
                const sloc = slocDropdown.find(sloc => sloc.value === location.CustSlocID);

                if (branch && !preSelectedBranches.some(b => b.value === branch.value)) {
                    preSelectedBranches.push(branch);
                }
                if (sloc && !preSelectedSlocs.some(s => s.value === sloc.value)) {
                    preSelectedSlocs.push({
                        label: sloc.label,
                        value: sloc.value,
                        ReportingToCode: sloc.ReportingToCode
                    });
                }
            });

            // Only update state if values actually changed
            if (JSON.stringify(preSelectedBranches) !== JSON.stringify(selectedBranches)) {
                setSelectedBranches(preSelectedBranches);
            }
            if (JSON.stringify(preSelectedSlocs) !== JSON.stringify(selectedSlocs)) {
                setSelectedSlocs(preSelectedSlocs);
            }

            // Filter Slocs based on selected branches
            const filtered = slocDropdown.filter(sloc =>
                preSelectedBranches.some(branch => branch.value === sloc.ReportingToCode)
            );

            setFilteredSlocs(filtered);
        }
    }, [storageLocation, branchDropdown, slocDropdown]);

    const handleBranchChange = (selected) => {
        setSelectedBranches(selected);
        setErrorMessage("");

        const branchCodes = selected.map(branch => branch.BranchCode);

        // ✅ Keep only Slocs belonging to selected branches
        const filtered = slocDropdown.filter(sloc => branchCodes.includes(sloc.ReportingToCode));
        setFilteredSlocs(filtered);

        // ✅ Update selected Slocs in MultiSelect
        const autoSelectedSlocs = filtered.map(sloc => ({
            label: sloc.label,
            value: sloc.value,
            ReportingToCode: sloc.ReportingToCode
        }));
        setSelectedSlocs(autoSelectedSlocs);

        // ✅ Update the storageLocation table without deleting all rows
        setStorageLocation(prev => {
            // 1️⃣ Remove only Slocs belonging to unchecked branches
            const filteredStorageLocation = prev.filter(location =>
                branchCodes.includes(location.BranchID)
            );

            // 2️⃣ Add new Slocs from selected branches (avoid duplicates)
            const newStorageLocations = autoSelectedSlocs.map(sloc => {
                const branch = selected.find(branch => branch.BranchCode === sloc.ReportingToCode);
                return {
                    BranchID: branch.value,
                    BranchName: branch.label,
                    CustSlocID: sloc.value,
                    StorageLocationName: sloc.label
                };
            });

            return [...filteredStorageLocation, ...newStorageLocations];
        });
    };


    // const handleSlocChange = (selected) => {
    //     setSelectedSlocs(selected);
    //     setErrorMessage("");
    // };

    // const handleSlocChange = (selected) => {
    //     setSelectedSlocs(selected);
    //     setErrorMessage("");

    //     // Find removed Slocs (unchecked by the user)
    //     const removedSlocs = storageLocation.filter(
    //         location => !selected.some(sloc => sloc.value === location.CustSlocID)
    //     );

    //     if (removedSlocs.length > 0) {
    //         // Update storageLocation by removing unchecked Slocs
    //         setStorageLocation(storageLocation.filter(
    //             location => selected.some(sloc => sloc.value === location.CustSlocID)
    //         ));
    //     }
    // };

    const handleSlocChange = (selected) => {
        setSelectedSlocs(selected);
        setErrorMessage("");

        // Update storageLocation by removing deselected Slocs
        const updatedStorageLocation = storageLocation.filter(
            location => selected.some(sloc => sloc.value === location.CustSlocID)
        );
        setStorageLocation(updatedStorageLocation);

        // ✅ Remove branches that no longer have any Slocs selected
        const remainingBranchCodes = selected.map(sloc => sloc.ReportingToCode);
        const updatedSelectedBranches = selectedBranches.filter(branch =>
            remainingBranchCodes.includes(branch.value)
        );
        setSelectedBranches(updatedSelectedBranches);

        // ✅ Recalculate filtered Slocs for selected branches
        const filtered = slocDropdown.filter(sloc =>
            updatedSelectedBranches.some(branch => branch.value === sloc.ReportingToCode)
        );
        setFilteredSlocs(filtered);
    };


    const handleAddStorage = () => {
        if (selectedBranches.length === 0 || selectedSlocs.length === 0) {
            setErrorMessage("Please select at least one Branch and Sloc.");
            return;
        }

        const newStorageLocations = [];
        let duplicateFound = false;

        selectedBranches.forEach(branch => {
            selectedSlocs.forEach(sloc => {
                if (sloc.ReportingToCode !== branch.BranchCode) return;

                const isDuplicate = storageLocation.some(
                    location =>
                        location.BranchID === branch.value &&
                        location.CustSlocID === sloc.value
                );

                if (!isDuplicate) {
                    newStorageLocations.push({
                        BranchID: branch.value,
                        BranchName: branch.label,
                        CustSlocID: sloc.value,
                        StorageLocationName: sloc.label,
                    });
                } else {
                    duplicateFound = true;
                }
            });
        });

        if (duplicateFound) {
            setErrorMessage("Selected Branch-Sloc combinations already exist.");
        }

        if (newStorageLocations.length > 0) {
            setStorageLocation(prev => [...prev, ...newStorageLocations]);
            setSelectedBranches([]);
            setSelectedSlocs([]);
            setErrorMessage(""); // Clear error message if new locations were added
        }
    };

    // const handleRemoveStorage = (index) => {
    //     setStorageLocation(prev => prev.filter((_, i) => i !== index));
    // };

    const handleRemoveStorage = (index) => {
        const updatedStorageLocation = [...storageLocation];
        const removedItem = updatedStorageLocation.splice(index, 1)[0];
        setStorageLocation(updatedStorageLocation);

        // Remove from selectedSlocs
        const updatedSelectedSlocs = selectedSlocs.filter(sloc => sloc.value !== removedItem.CustSlocID);
        setSelectedSlocs(updatedSelectedSlocs);

        // Check if any branches still have slocs left
        const updatedSelectedBranches = selectedBranches.filter(branch =>
            updatedStorageLocation.some(location => location.BranchID === branch.value)
        );
        setSelectedBranches(updatedSelectedBranches);

        // Update filtered Slocs based on remaining selected branches
        const filtered = slocDropdown.filter(sloc =>
            updatedSelectedBranches.some(branch => branch.value === sloc.ReportingToCode)
        );
        setFilteredSlocs(filtered);
    };

    const AddUserManagementSlocData = (e) => {
        e.preventDefault();

        if (storageLocation.length === 0) {
            setErrorMessage("No storage locations added. Please add a storage location before saving.");
            return;
        }

        const slocData = {
            UserID: userID,
            UserSloc: storageLocation.map(location => ({
                BranchID: location.BranchID,
                CustSlocID: location.CustSlocID,
            })),
        };

        const requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(slocData),
        };

        dispatch(postUserManagementSlocDatas(requestOption, props.handleCloseSlocModal, userManagenemtData));
    };

    const handleCloseSlocModal = () => {
        setSelectedBranches([]);  // Reset selected branches
        setSelectedSlocs([]);     // Reset selected slocs
        setFilteredSlocs([]);     // Reset filtered slocs
        setErrorMessage("");      // Clear error message
        props.handleCloseSlocModal();  // Close the modal
    };

    return (
        <Modal show={props.openSlocModal} onHide={handleCloseSlocModal} className="add-customer-modal">
            <Modal.Header closeButton>
                <Modal.Title>Add Storage Locations</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="customer-form-fields customer-branch-plant-form-fields">
                    <Col>
                        <Row>
                            <Col md={12}>
                                <div>
                                    <label>Username</label>
                                    <Form.Control
                                        type="text"
                                        value={userName}
                                        onChange={(e) => setUserName(e.target.value)}
                                        placeholder="Enter Username"
                                    />
                                </div>
                            </Col>
                        </Row>
                        <div className="wq-modal-table-container">
                            <Row>
                                <Col md={6}>
                                    <div>
                                        <label>Plant</label>
                                        <MultiSelect
                                            options={branchDropdown}
                                            value={selectedBranches}
                                            onChange={handleBranchChange}
                                            labelledBy="Select Plant"
                                        />
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div>
                                        <label>Sloc</label>
                                        <MultiSelect
                                            // options={filteredSlocs}
                                            options={filteredSlocs.length ? filteredSlocs : selectedSlocs}
                                            value={selectedSlocs}
                                            onChange={handleSlocChange}
                                            labelledBy="Select Sloc"
                                        />
                                    </div>
                                </Col>
                            </Row>

                            {errorMessage && (
                                <Row>
                                    <Col md={12} className="text-danger text-center">
                                        {errorMessage}
                                    </Col>
                                </Row>
                            )}

                            {/* <Row>
                                <Col className="d-flex justify-content-center pt-4">
                                    <SbAddBtn btnName="Add Storage Location" onClickEffect={handleAddStorage} />
                                </Col>
                            </Row> */}

                            <Row className="add-sloc-table-div">
                                <TableContainer component={Paper} sx={{ maxHeight: 440 }} className="table-container add-sloc-table-container" style={{ boxShadow: "none" }}>
                                    <Table stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className="table-header-div">Plant</TableCell>
                                                <TableCell className="table-header-div">Sloc</TableCell>
                                                <TableCell className="table-header-div">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {storageLocation.length > 0 ? (
                                                storageLocation.map((location, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{location.BranchName}</TableCell>
                                                        <TableCell>{location.StorageLocationName}</TableCell>
                                                        <TableCell>
                                                            <img src={deleteImg} alt="Delete" onClick={() => handleRemoveStorage(index)} style={{ cursor: "pointer" }} />
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={3} align="center">
                                                        <img src={noDataFound} alt="No Data Found" style={{ height: "250px", width: "280px" }} />
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <SbCancelBtn btnName="Cancel" onClickEffect={handleCloseSlocModal} />
                <SBSaveUpdateBtn btnName="Save" onClickEffect={AddUserManagementSlocData} />
            </Modal.Footer>
        </Modal>
    );
};

export default AddSlocModal;



